<div class="mat-elevation-z8 table-container">
    <table [dataSource]="emailDataSource" mat-table
           matSort multiTemplateDataRows
           (matSortChange)="onSortData($event)">

      <ng-container [matColumnDef]="tableColumns.Icons">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let row" mat-cell>

          <!-- Send Email Icon -->
          <mat-icon *ngIf="showIcon(row, IconName.Send)"
                    class="mat-primary-color hand-cursor font-medium" matTooltip="SEND email to {{getToAddress(row)}}"
                    (click)="onClickToggleIcons($event, row)">
            send
          </mat-icon>

          <!-- Duplicate Email Icon -->
          <ng-container *ngIf="row[tableColumns.IsSent];">
            <!--Allow duplicate functionality for Emails -->
            <app-duplicate defaultIcon="redo"
                           tooltip="RESEND email"
                           [customCssClasses]="['hand-cursor', 'font-medium']"
                           (duplicateItem)="onClickDuplicate($event, row)"></app-duplicate>

          </ng-container>

          <!-- Send Email Confirmation Icons -->
          <ng-container *ngIf="row.sendEmailChecked">
            <mat-icon class="mat-primary-color hand-cursor font-medium"
                      matTooltip="CONFIRM Send to {{getToAddress(row)}}"
                      (click)="onClickSendEmailConfirmed($event, row)">
              done
            </mat-icon>
            <mat-icon class="hand-cursor font-medium"
                      matTooltip="CANCEL Send"
                      color="warn"
                      (click)="onClickToggleIcons($event, row)">
              close
            </mat-icon>
          </ng-container>

          <!-- Reset Email Icon -->
            <ng-container *ngIf="showIcon(row ,IconName.Reset)">
            <mat-icon class="mat-primary-color hand-cursor font-medium" matTooltip="RESET email"
                      (click)="onClickToggleResetEmailIcons($event, row)">
              restart_alt
            </mat-icon>
          </ng-container>

          <!-- Reset Email Confirmation Icons -->

          <ng-container *ngIf="row.resetEmailConfirmation">
            <mat-icon class="mat-primary-color hand-cursor font-medium"
                      matTooltip="CONFIRM Reset email {{row[tableColumns.EmailId]}}"
                      (click)="onClickResetEmailConfirmed($event, row)">
              done
            </mat-icon>
            <mat-icon class="hand-cursor font-medium"
                      matTooltip="CANCEL Reset"
                      color="warn"
                      (click)="onClickToggleResetEmailIcons($event, row)">
              close
            </mat-icon>
          </ng-container>

          <mat-icon *ngIf="row.emailSentBusyCounter > 0" class="m-l-10">
            <mat-spinner diameter="20"></mat-spinner>
          </mat-icon>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.EmailId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Email</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.EmailId]}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.FromAddress">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>From</th>
        <td *matCellDef="let row" mat-cell
            [matTooltip]="row[tableColumns.FromAddress]">
          {{row[tableColumns.FromAddress] | truncateText: {sliceEnd: 30, append: '...'} }}
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.ToAddress">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>To</th>
        <td *matCellDef="let row"
            mat-cell
            [matTooltip]="row[tableColumns.ToAddress]">


          <ng-container>
            <ng-container *ngIf="!row[tableColumns.IsSent]">
              <mat-icon *ngIf="!row?.isEditEmail" class="mat-primary-color hand-cursor font-medium"
                        matTooltip="UPDATE address"
                        (click)="onClickEditAddress($event, row)">edit
              </mat-icon>
            </ng-container>
            <ng-container *ngIf="row?.isEditEmail; else displayAddress">
              <mat-form-field>
                <input [formControl]="emailOverrideFormControl" matInput/>
                <button (click)="onClickCancelEditAddress($event, row)" class="mr2"
                        mat-button mat-icon-button matSuffix>
                  <mat-icon matTooltip="Cancel edit" style="color: grey;">cancel</mat-icon>
                </button>
                <button (click)="onClickSaveAddress($event, row)"
                        mat-button mat-icon-button matSuffix>
                  <mat-icon class="table-icon" matTooltip="Save address">save</mat-icon>
                </button>
              </mat-form-field>
            </ng-container>

            <ng-template #displayAddress>
              <ng-container *ngIf="!row?.editedToAddress; else showEditedAddress">
                {{row[tableColumns.ToAddress] | truncateText: {sliceEnd: 30, append: '...'} }}
              </ng-container>
              <ng-template #showEditedAddress>
                {{row?.editedToAddress | truncateText: {sliceEnd: 30, append: '...'} }}
              </ng-template>
            </ng-template>

          </ng-container>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Subject">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Subject</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.Subject]}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.CommunicationTriggerType">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Communication Type</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.CommunicationTriggerType]?.name}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.TriggerId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Trigger ID</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.TriggerId]}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.IsSent">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Sent</th>
        <td *matCellDef="let row" mat-cell> {{row[tableColumns.IsSent] ? 'Y' : 'N'}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.PdfReport">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Report</th>
        <td *matCellDef="let row" mat-cell>
          <mat-icon class="hand-cursor pdf-icon" *ngIf="row[tableColumns.TriggerId] && row['attachment']"
                    (click)="onClickGeneratePdfReport($event, row)">picture_as_pdf
          </mat-icon>
        </td>
      </ng-container>

      <!--Expanded Section -->
      <ng-container matColumnDef="expandedDetail">
        <td *matCellDef="let row" [attr.colspan]="emailDisplayedColumns.length" mat-cell>
          <div [@detailExpand]="row == emailExpandedRow ? 'expanded' : 'collapsed'"
               class="row-detail-container">
            <b>Triggered By: </b>{{row.createdBy}}<br>
            <b>Triggered At: </b>{{row.created | date: dateTimeFormat}}<br>
            <b>Sent By: </b>{{row.updatedBy}}<br>
            <b>Sent At: </b>{{row.updated | date: dateTimeFormat}}<br>
            <b>Validation Message: </b>{{row.validationMessage}}<br>
            <b>CC: </b>{{row?.ccAddress}}<br>
            <b>BCC: </b>{{row?.bccAddress}}<br>
            <ng-container *ngIf="row?.body">
              <div class="email m-t-10 m-b-15">
                <b>Subject: </b>{{row?.subject}}<br>
                <b>Message: </b> <br/>
                <div [innerHTML]="row.body"></div>
              </div>
            </ng-container>
          </div>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="emailDisplayedColumns;" mat-header-row></tr>
      <tr class="row"
          mat-row
          *matRowDef="let row; columns: emailDisplayedColumns;"
          [class.expanded-row]="emailExpandedRow == row"
          (click)="onRowClick($event, row)">
      </tr>
      <tr *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row" mat-row></tr>
    </table>

    <mat-paginator #emailPaginator
                   [length]="emailTableControl.length" [pageIndex]="0"
                   [pageSizeOptions]="emailTableControl.pageSizeOptions"
                   [pageSize]="emailTableControl.pageSize"
                   (page)="onPageChanged($event)">
    </mat-paginator>
  </div>

